import * as cp from 'child_process'

/**
 * Get commit info
 */
export function getCommitInfo() {
  const hash = cp.execSync('git rev-parse HEAD').toString().trim().slice(0, 7)
  const msg = cp.execSync('git log -1 --pretty=%B').toString().trim()

  return [hash, msg]
}
